// extracted by mini-css-extract-plugin
module.exports = {"root":"NftFormAssetSection_root__g9i_Z","amount":"NftFormAssetSection_amount__0vDAc"};